import React, { Fragment } from "react";
import "./styles/homeMobile.css";

//provider
import { stateAdmison } from "../Context/store";
import { PAGINA_INICIO, PAGINA_UNO } from "../rutas";

//components
import { LayoutMobile } from "./LayoutMobile";

//pages
import { HomePageMobile } from "./HomePageMobile";

//activos
import HeaderImageRigthSvg from "../../../Activos/Imagenes/Modulos/Home/HeaderImageRigth.svg";
import ImageHomeLeftBottom from "../../../Activos/Imagenes/Modulos/Home/ImageHomeLeftBottom.svg";

export const HomeMobile = () => {
  const { navigatioPage } = stateAdmison();

  return (
    <Fragment>
      <div className="home-container">
        <div className="container-header-img">
          <img
            className="img-background"
            src={HeaderImageRigthSvg}
            alt={"Avatar de HeaderRigth"}
          />
        </div>
        {navigatioPage === PAGINA_INICIO ? <HomePageMobile /> : null}

        {navigatioPage === PAGINA_UNO ? <LayoutMobile /> : null}

        {navigatioPage === PAGINA_INICIO ? (
          <img
            className="img-left-bottom"
            src={ImageHomeLeftBottom}
            alt={"."}
          />
        ) : null}
      </div>
    </Fragment>
  );
};
